export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00499.bc66be82.png";